import script from "./NewFilmDrawer.vue?vue&type=script&setup=true&lang=js"
export * from "./NewFilmDrawer.vue?vue&type=script&setup=true&lang=js"

import "./NewFilmDrawer.vue?vue&type=style&index=0&id=37351af2&scoped=true&lang=css"

import exportComponent from "/var/lib/jenkins/workspace/duanju_admin_vue_live/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-37351af2"]])

export default __exports__